export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-0ec61ad90d47b21a84ecc22f471db352.svg";